export default function errorHandler(error: Response) {
    if (error.status === 500) {
        console.log('internal server error');
    } else if (error.status === 400) {
        console.log('Page not found');
    }
}
